var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label tw-bg-gray-330 tw-text-gray-770"},[_c('SvgIcon',{staticClass:"tw-w-4 tw-h-4",attrs:{"name":"icon-private"}}),_c('span',{staticClass:"tw-ml-2"},[_vm._v("Private")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }